import actions from './actions.js'
import mutations from './mutations'
import getters from './getters.js'

const state = {
  documents: [],
  folderPickerCurrentDir: [],
  selectedItemId: '',
  selectedItemName: '',
  nextLink: '',
  foldersNextLink: '',
  sharepointCodingPoliciesDriveId: 'b!jD67Yp40tESxlvmv11jQY9vg8CcxHdZDjIu1Q_VbYwml55FuDYjiSKVSWeu7ALVg',
  fileAccept: [
    { ext: 'jpg', icon: 'mdi-image' },
    { ext: 'jpeg', icon: 'mdi-image' },
    { ext: 'png', icon: 'mdi-image' },
    { ext: 'bmp', icon: 'mdi-image' },
    { ext: 'gif', icon: 'mdi-image' },
    { ext: 'tiff', icon: 'mdi-image' },
    { ext: 'txt', icon: 'mdi-file-document-box-outline' },
    { ext: 'pdf', icon: 'mdi-file-pdf-box' },
    { ext: 'doc', icon: 'mdi-file-word-box' },
    { ext: 'docx', icon: 'mdi-file-word-box' },
    { ext: 'xls', icon: 'mdi-file-excel-box' },
    { ext: 'xlsx', icon: 'mdi-file-excel-box' },
    { ext: 'zip', icon: 'mdi-file-cabinet' },
    { ext: 'rar', icon: 'mdi-file-cabinet' },
    { ext: '7z', icon: 'mdi-file-cabinet' },
    { ext: 'msg', icon: 'mdi-outlook' },
    { ext: 'on', icon: 'mdi-onenote' } // not really a valid extension - using to trick
  ]
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
